import { ICandidateLanguage } from "@core/models/common";

const language1 = {
  [ICandidateLanguage.id]: 163903,
  [ICandidateLanguage.lang]: {
    id: 1,
    name: "Français",
  },
  [ICandidateLanguage.level]: {
    id: 3,
    name: "Expert",
  },
};

const language2 = {
  [ICandidateLanguage.id]: 163905,
  [ICandidateLanguage.lang]: {
    id: 769,
    name: "Afrikaans",
  },
  [ICandidateLanguage.level]: {
    id: 1,
    name: "Débutant",
  },
};

export const extraLanguagesMocks = [language1, language2];
